import React from 'react';
import * as Icon from 'react-bootstrap-icons';

import ConfirmationButton from '../../../app/components/ConfirmationButton';

interface Props {
  examId: string;
  onRemove: (key: string) => void;
}

export const ExamRemoveFromListLink: React.FC<Props> = ({
  examId,
  onRemove,
}) => {
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={e => e.stopPropagation()}>
      <ConfirmationButton
        variant="btn-info"
        tooltip="Usuń badanie z listy"
        confirmation="Czy na pewno usunąć badanie z listy?"
        onOK={() => onRemove(examId)}
      >
        <Icon.Trash />
      </ConfirmationButton>
    </div>
  );
};
